import moment from 'moment';
import { useState } from 'react';
import { DatePicker, Text } from 'shell/components';

const DatePickerDemo = () => {
    const [value1, setValue1] = useState(null);
    const [value2, setValue2] = useState(moment().hour(0).minute(0).second(0).millisecond(0));
    const [value3, setValue3] = useState(moment().hour(0).minute(0).second(0).millisecond(0));
    const [value4, setValue4] = useState(moment().hour(0).minute(0).second(0).millisecond(0));

    return (
        <>
            <Text variant={'sh1'}>DatePicker</Text>
            <DatePicker
                disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                label={'Select a Date'}
                value={value1}
                onChange={setValue1}
            />
            <DatePicker
                allowTimeSelection
                disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                label={'Select a Date'}
                value={value2}
                onChange={setValue2}
            />
            <DatePicker
                disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                forceTimeSelection
                label={'Select a Date'}
                value={value3}
                onChange={setValue3}
            />
            <DatePicker
                disabled
                disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                label={'Select a Date'}
                value={value4}
                onChange={setValue4}
            />
        </>
    );
};

export default DatePickerDemo;
